import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function EditConsultant() {
    const {cons_id} = useParams();
    const [errorMsg, seterrorMsg] = useState('');
    const [gender, setGender] = useState("male"); // set default value to "male"
    const [succesMsg, setsuccessMsg] = useState('');
    const [consDept, setConsDept] = useState([]);
    const [registerFormData, setRegisterFormData] = useState({
        "consultant": '',
        "specialization": '',
        "department": '',
        "fees": '',
        "drfees": '',
        "visiting": '',
        "mobile": '',
        "address": '',
        "gender": '',
        "email": '',
        "hours": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        try {
            axios.get(baseUrl + 'edit-consultant/' + cons_id)
                .then(function (response) {
                    setRegisterFormData({
                        consultant: response.data.consultant,
                        specialization: response.data.specialization,
                        department: response.data.department,
                        fees: response.data.fees,
                        drfees: response.data.drfees,
                        visiting: response.data.visiting,
                        mobile: response.data.mobile,
                        address: response.data.address,
                        gender: response.data.gender,
                        email: response.data.email,
                        hours: response.data.hours,
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        axios.get(`${baseUrl}cons-dept/`)
            .then((response) => {
                setConsDept(response.data);
            })
            .catch((error) => {
                console.error("Error fetching departments:", error);
            });
    }, []);
    const handleInputChange = (event) => {
        setGender(event.target.value);
    };
    const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]: event.target.value
        })
    };
    const submitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData();
        const department = document.getElementById("department").value;
        const visiting = document.getElementById("visiting").value;
        const hours = document.getElementById("hours").value;
        formData.append('consultant', registerFormData.consultant);
        formData.append('specialization', registerFormData.specialization);
        formData.append('department', department);
        formData.append('fees', registerFormData.fees);
        formData.append('drfees', registerFormData.drfees);
        formData.append('visiting', visiting);
        formData.append('mobile', registerFormData.mobile);
        formData.append('address', registerFormData.address);
        formData.append('gender', gender);
        formData.append('hours', hours);
        formData.append('email', registerFormData.email);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        axios.put(baseUrl + 'edit-consultant/' + cons_id, formData)
            .then((response) => {
                if (response.status == 200 || response.status == 201) {
                    Swal.fire({
                        title: 'consultant has been added.',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setTimeout(() => {
                        window.location.href = '/add-consultant/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to add consultant. Please try again later.',
                    'error'
                );
            });
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-8 col-12">
                    <div className='card'>
                        <h4 className='card-header text-center'>Update Consultant</h4>
                        <div className='card-body'>
                            <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                            {succesMsg && <p className="text-success">{succesMsg}</p>}
                            {errorMsg && <p className="text-danger">{errorMsg}</p>}
                            <form>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Consultant" className="form-label">Consultant Name</label>
                                        <input type="text" placeholder="consultant Name" className="form-control"
                                               name="consultant" value={registerFormData.consultant}
                                               onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="specialization" className="form-label">specialization</label>
                                        <input type="text" placeholder="specialization" className="form-control"
                                               name="specialization" value={registerFormData.specialization}
                                               onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Role" className="form-label">Department</label>
                                        <select
                                            className="form-control"
                                            name="department"
                                            id="department"
                                            value={registerFormData.department}
                                            onChange={inputHandler}
                                        >
                                            <option value="">-- Select Department --</option>
                                            {consDept.map((dept, index) => (
                                                <option key={index} value={dept.department}>
                                                    {dept.department}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Fees" className="form-label">Fees</label>
                                        <input type="number" maxLength={10} placeholder="Fees" className="form-control"
                                               name="fees" value={registerFormData.fees} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="DrFees" className="form-label">DrFees</label>
                                        <input type="number" maxLength={10} placeholder="DrFees"
                                               className="form-control"
                                               name="drfees" value={registerFormData.drfees} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Role" className="form-label">Visiting Hour</label>
                                        <select className="form-control" value={registerFormData.visiting}
                                                onChange={inputHandler}
                                                name="visiting" id="visiting">
                                            <option value="Full-time">Full-time</option>
                                            <option value="Part-time">Part-time</option>
                                            <option value="On-Call">On-Call</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="Mobile" className="form-label">Mobile</label>
                                        <input type="number" maxLength={10} placeholder="Mobile"
                                               className="form-control"
                                               name="mobile" value={registerFormData.mobile} onChange={inputHandler}/>
                                    </div>
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Address" className="form-label">Address</label>
                                        <input type="text" placeholder="Address" className="form-control"
                                               name="address" value={registerFormData.address} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6 mb-3">
                                        <label htmlFor="Gender" className="form-label">Gender</label>
                                        <label className="radio-inline">
                                            <input type="radio" name="gender" value="male" checked={gender === "male"}
                                                   onChange={handleInputChange}/> Male
                                        </label>
                                        <label className="radio-inline">
                                            <input type="radio" name="gender" value="female"
                                                   checked={gender === "female"}
                                                   onChange={handleInputChange}/> Female
                                        </label>
                                        <label className="radio-inline">
                                            <input type="radio" name="gender" value="transgender"
                                                   checked={gender === "transgender"}
                                                   onChange={handleInputChange}/> Transgender
                                        </label>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="hours" className="form-label">Hours</label>
                                        <select className="form-control" value={registerFormData.hours}
                                                onChange={inputHandler}
                                                name="hours" id="hours">
                                            <option value="2">2</option>
                                            <option value="4">4</option>
                                            <option value="6">6</option>
                                            <option value="8">8</option>
                                            <option value="10">10</option>
                                        </select>
                                    </div>
                                    <div className="col-md-3 mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input type="text" placeholder="Email" className="form-control"
                                               name="email" value={registerFormData.email} onChange={inputHandler}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12 text-center">
                                        <button type="button" onClick={submitHandler}
                                                className="btn btn-success">Update
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
export default EditConsultant;
